import React from 'react';
import fadoelTypes from '../../content/commerce/fadoelTypes';
import getFadoelAlias from '../../content/commerce/fadoelAliases';
import { Row, Col } from '../../components/grid';
import FadoelLink from './FadoelLink';


export default ({
  type,
}) => {
  const typeAlias = getFadoelAlias(type);
  const {
    [typeAlias]: {
      allTypes,
    } = { allTypes: [] },
  } = fadoelTypes;
  return (
    <Row>
      {allTypes.map(
        varenr => (
          <Col xs={12} sm={6} md={3} key={varenr} padding="0 15px 10px 15px">
            <FadoelLink varenr={varenr} />
          </Col>
        ),
      )}
    </Row>
  );
};
